export default __webpack_public_path__ + "static/media/twitter.e4a72080.svg";